// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__30XIh","content":"GlobalSearch_content__15qKi"};